<template>
  <main id="main">
    <template v-if="$page">
      <div class="section --centered">
        <div class="section__content">
          <h1 class="title --main">{{ $page.header.title }}</h1>
          <p>{{ $page.header.description }}</p>
        </div>
        <Tagline :text="$page.header.tagline" />
        <div class="section__content">
          <Image :source="$page.header.image" class="--home" />
          <LangRouterLink :to="{ name: ROUTES.AUTH.LOGIN }" class="button">
            {{ $beet.options.hunt.labels.auth.login }}
          </LangRouterLink>
          <TermsBlock />
        </div>
      </div>
    </template>
  </main>
</template>

<script>
import { TermsBlock } from '@/components/blocks'
import { Image, LangRouterLink } from '@/components/global'
import { Tagline } from '@/components/small'
import { PageMetaMixin, UsesRoutesMixin } from '@/mixins'

export default {
  name: 'Home',
  beetPage: 'hunt_home',
  mixins: [PageMetaMixin, UsesRoutesMixin],
  components: {
    Image,
    LangRouterLink,
    Tagline,
    TermsBlock,
  },
}
</script>
